'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformString = transformString;
exports.removeDivElements = removeDivElements;
exports.removeBrElements = removeBrElements;
exports.removeLeadingBrElements = removeLeadingBrElements;
exports.removeTrailingBrElements = removeTrailingBrElements;
exports.removeNonBreakingSpaces = removeNonBreakingSpaces;
exports.removeEmptyEmphasisElements = removeEmptyEmphasisElements;
exports.removeEmptyParagraphElements = removeEmptyParagraphElements;
exports.removeEmptyStrongElements = removeEmptyStrongElements;
// @param {String} String (contenteditable innerHTML) to which formatting should be applied
// Returns a function accepting an infinite number of function arguments.
// The first function argument is called with transformString's string argument.
// Subsequent arguments are called with the return value of the previous.
function transformString(str) {
  return function transform() {
    return [].concat(Array.prototype.slice.call(arguments)).reduce(function (str, func) {
      return func(str);
    }, str);
  };
}

// Removes inline instances of <div> variants
function removeDivElements(str) {
  return str.replace(/<\/?(div)>/gi, '');
}

// Removes inline instances of <br> variants
function removeBrElements(str) {
  return str.replace(/< ?br ?\/?>/gi, '');
}

function removeLeadingBrElements(str) {
  var regExp = /^(< ?br ?\/?>)+/gi;

  return str.replace(regExp, '');
}

function removeTrailingBrElements(str) {
  var regExp = /(< ?br ?\/?>)+\s*$/gi;

  return str.replace(regExp, '');
}

// Remove inline instances of &nbsp;, the character entity reference
// Does not remove numeric character reference
function removeNonBreakingSpaces(str) {
  return str.replace(/&nbsp;/g, '');
}

function removeEmptyEmphasisElements(str) {
  var regExp = /<em><\/em>/gi;
  var newStr = str.replace(regExp, '');

  if (!!newStr.match(regExp)) {
    return removeEmptyEmphasisElements(newStr);
  }

  return newStr;
}

function removeEmptyParagraphElements(str) {
  var regExp = /<p><\/p>/gi;
  var newStr = str.replace(regExp, '');

  if (!!newStr.match(regExp)) {
    return removeEmptyParagraphElements(newStr);
  }

  return newStr;
}

function removeEmptyStrongElements(str) {
  var regExp = /<strong><\/strong>/gi;
  var newStr = str.replace(regExp, '');

  if (!!newStr.match(regExp)) {
    return removeEmptyStrongElements(newStr);
  }

  return newStr;
}